import { render, staticRenderFns } from "./FoodcourtPlatformList.vue?vue&type=template&id=2bdcad7f&scoped=true"
import script from "./FoodcourtPlatformList.vue?vue&type=script&lang=js"
export * from "./FoodcourtPlatformList.vue?vue&type=script&lang=js"
import style0 from "./FoodcourtPlatformList.vue?vue&type=style&index=0&id=2bdcad7f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdcad7f",
  null
  
)

export default component.exports